import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./page/login";
import ReportPage from "./page/report";
import "./App.css";

function App() {
  // กำหนด state
  const [token, setToken] = useState(() => localStorage.getItem("sessiontoken"));
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  });

  // ตรวจสอบ token
  useEffect(() => {
    if (!token) {
      localStorage.removeItem("user");
      setUser(null);
    }
  }, [token]);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            token ? (
              <Navigate to="/report" />
            ) : (
              <LoginPage
                setToken={setToken}
                setUser={setUser}
              />
            )
          }
        />
        <Route
          path="/report"
          element={
            token ? (
              <ReportPage 
                token={token} 
                user={user}
                setToken={setToken}  // ส่ง function setToken
                setUser={setUser}    // ส่ง function setUser
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;